// extracted by mini-css-extract-plugin
export var askAiIcon = "_qg-9";
export var container = "_qg-0";
export var groupSeparator = "_qg-a";
export var highlight = "_qg-4";
export var resultIcon = "_qg-5";
export var resultItem = "_qg-7";
export var resultSubtitle = "_qg-3";
export var resultTitle = "_qg-2";
export var resultsList = "_qg-1";
export var searchGroup = "_qg-6";
export var selected = "_qg-8";